import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { apiClient } from '.';
import { ChatMessage, GetChatRoom } from '@models/chat';

const BASE_URL = '/admin/v2/chats';

export const getChatRooms = (query: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<GetChatRoom>>(`${BASE_URL}/rooms`, { params: query });
};

export const getChatRoomMessages = (roomId: string, query: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<ChatMessage>>(`${BASE_URL}/rooms/${roomId}/messages`, { params: query });
};
